import { render, staticRenderFns } from "./Sm600Orange.vue?vue&type=template&id=47c3ffe0&scoped=true&"
var script = {}
import style0 from "./Sm600Orange.vue?vue&type=style&index=0&id=47c3ffe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3ffe0",
  null
  
)

export default component.exports